import React, { FC } from 'react'
import Head from 'next/head'

import { useBrandName, useIsBrandingPending } from '@/layout/branding-theme'

// The product mark, not translatable copy.
export const DEFAULT_BRAND_NAME = 'Grid'
const TITLE_SEPARATOR = ' | '

/**
 * Builds a tab title prefixed with the brand a reseller published, or Grid's.
 * @param parts - the page's own title segments, most general first
 * @param brandName - the brand prefix; omitted while the branding is still being looked up
 * @returns the joined title
 */
export const buildPageTitle = (parts: string[], brandName?: string | null) => (
  (brandName ? [brandName, ...parts] : parts).join(TITLE_SEPARATOR)
)

type PageTitleProps = { parts: string[] }

/**
 * Sets the browser tab title. The prefix waits for the branding, so a reseller's tab never
 * flashes Grid's name.
 * @param props - component props
 * @param props.parts - the page's own title segments, most general first
 * @returns a `<Head>` holding the tab title
 */
export const PageTitle: FC<PageTitleProps> = ({ parts }) => {
  const brandNameFromContext = useBrandName()
  const isPending = useIsBrandingPending()
  const brandName = isPending ? null : brandNameFromContext || DEFAULT_BRAND_NAME

  return (
    <Head>
      <title>{buildPageTitle(parts, brandName)}</title>
    </Head>
  )
}
